export const checkStatus = (response) =>
  response.ok
    ? Promise.resolve(response)
    : response.json().then((err) => Promise.reject(err));

export const fetchRetry = async (url, options, limit, delay) => {
  return new Promise((resolve, reject) => {
    function success(response) {
      response.ok ? resolve(response) : failure(response);
    }
    function failure(response) {
      limit--;
      if (limit) {
        setTimeout(fetchUrl, delay);
      } else {
        //rejct after trying `limit` times
        response.json().then((err) => reject(err));
      }
    }
    function fetchUrl() {
      return fetch(url, options).then(success);
    }
    fetchUrl();
  });
};

export const parseJSON = (response) => response.json();

export const generalError = () => {
  throw Error(
    'Sorry, something went wrong. Please try again, and contact us if the issue continues.'
  );
};



// WEBPACK FOOTER //
// ./src/api/utils.js